<template>
  <div id="index">
    <!-- content -->
    <div class="system_index">
      <el-row class="index_content" :gutter="10">
        <el-col :span="24" class="part_1">
          <el-col :span="17">
            <div class="bgWhite">
              <div class="common-head">
                <el-menu mode="horizontal" :default-active="latestMsg.activeName" class="indexNewsList"
                  @select="handleClick">
                  <el-menu-item :index="item.value" v-for="item in noticeType" :key="item.value">
                    <span slot="title">{{ item.label }}</span>
                  </el-menu-item>
                </el-menu>
                <span class="more" @click="goToMore()">更多</span>
              </div>
              <div class="common-body" style="align-items: flex-start;">
                <el-col :span="24" style="padding-left: 0; margin-bottom:0">
                  <el-carousel :interval="5000" arrow="always" indicator-position="none" height="280px"
                    style="margin-top:0px">
                    <el-carousel-item v-for="item in carousel" :key="item" :class="carouselHide"
                      style="cursor: pointer;">
                      <img height="280px" :src="item.src" alt width="100%" @click="goToview(item)" />
                      <h3 class="carousel_title" @click="goToview(item)">
                        {{ item.title }}
                      </h3>
                    </el-carousel-item>
                  </el-carousel>
                  <div class="cLoading" v-loading="carouselLoading" element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
                </el-col>
                <ul class="tzzx-list">
                  <li v-for="(item, index) in latestMsg.data" :key="index">
                    <div class="notice-list" @click="goToview(item)">
                      <p>
                        <span class="title" :title="item.title">{{ item.title }}</span>
                      </p>
                      <span class="date">{{ item.publish_time.substring(0, 10) }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="bgWhite">
              <div class="userinfoData">
                <popoverinfo ref="myrefpopover"
                  :avatar="userInfo.subject.avatar ? userInfo.subject.avatar : './base/images/layout/user.png'"
                  :baseinfo="baseinfo" @goToda="goToda" />
                <div @mouseenter="myself(userInfo.subject.loginName)">
                  <Headimg
                    :data="{name: userInfo && userInfo.subject && userInfo.subject.name ? userInfo.subject.name : '未知用户', url: userInfo.subject.avatar || './base/images/layout/user.png'}" />
                </div>
                <p class="userName">
                  {{userInfo && userInfo.subject && userInfo.subject.name ? userInfo.subject.name : '未知用户'}} <span
                    class="line"></span> {{ userData?.position }} {{jobLevel?.zj}}</p>
                <p class="welcome">亲爱的，这是您在智隆工作的<span class="work-day">{{ this.zzts }}</span>天</p>
                <div class="mytodo">
                  <div class="today">
                    <span class="nowWeek">{{ this.nowWeek }}</span>
                    <span>{{ this.nowDate }}</span>
                  </div>
                  <div class="line"></div>
                  <div @click="goToDB"><img :src="mytodoimg" class="iconsize"><span class="pdt10">我的待办</span></div>
                  <div @click="goToCC"><img :src="myccimg" class="iconsize"><span class="pdt10">抄送消息</span></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="index_content" :gutter="10">
        <el-col :span="24" class="part_1">
          <el-col :span="17">
            <div class="bgWhite">
              <div class="common-head">
                <span class="head-title"><img :src="yyzximg"><span class="title_span">最新服务</span></span>
                <span class="more" @click="goToFw()">更多</span>
              </div>
              <div class="common-body">
                <el-col :span="24" class="expressLane_content_div" v-loading="loadinglastList"
                  element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
                  <template v-if="lastList.length != 0">
                    <div v-for="(item, index) in lastList" :key="index" class="zxyx">
                      <div class="expressLane_content_xt" @click="goToFWXQ(item)">
                        <img :src="item.src" alt class="expressLane_img" />
                        <p>{{ item.appName }}</p>
                      </div>
                    </div>
                  </template>
                </el-col>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="bgWhite">
              <div class="common-head">
                <span class="head-title"><img :src="xdimg"><span class="title_span">心得体会</span></span>
                <span class="more" @click="goToxd()">更多</span>
              </div>
              <div class="common-body">
                <ul class="xdlist">
                  <li v-for="(item,index) in xdthData" :key="index">
                    <popoverinfo ref="refpopover" :avatar="item.avatr" :baseinfo="baseinfo" @goToda="goToda" />
                    <div class='useravatar' @mouseenter="getpopoverinfo(item,index)"><img :src="item.avatr" /></div>
                    <div class="xdlistinfo">
                      <div> <span class="xm">{{item.xm}}</span>
                        <span class="date">{{item.txrq}}</span>
                      </div>
                      <div class="xd" :title="item.xd">{{item.xd | ellipsis}}</div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="index_content yqlj">
        <div class="bgWhite">
          <div class="common-head">
            <span class="head-title" style="border-bottom:none"><img :src="yqljimg"><span
                class="title_span">友情链接</span></span>
          </div>
          <div class="common-yqlj">
            <ul>
              <li v-for="(item,index) in yqljlist" :key="index">
                <div>
                  <a :href="item.pcUrl" target="_blank">
                    <img :src="item.icons">
                    <span>{{item.appName}}</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-row>
      <el-row :span="24" class="zl_module">
        <span class="line">&nbsp;</span>
        <span class="font">{{ tenantName }}</span>
        <span class="line">&nbsp;</span>
      </el-row>
    </div>
    <el-dialog :title="dangan.title" :visible.sync="dangan.dialogVisible" width="60%" top="5vh"
      :before-close="handleClose">
      <danganView :loginName='dangan.loginName' :baseinfo="baseinfo" />
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/framework/util/auth'
import { mapGetters } from 'vuex'
import Headimg from '@/framework/components/common/headimg'
import { dateFormat } from '@/framework/util/date.js'
import { RESOURSE_CONFIG, TENANT } from '@/page/config/base_config'
import popoverinfo from '@/portal/base/Experience/components/popoverinfo.vue'
import danganView from '@/portal/base/Experience/components/danganDialog.vue'
export default {
  components: {
    Headimg, popoverinfo, danganView
  },
  data() {
    return {
      dangan: {
        loginName: '',
        dialogVisible: false,
        title: '档案'
      },

      baseallinfo: {},
      baseinfo: {},
      jobLevel: {},
      nowWeek: '',
      nowDate: '', // 今天得日期
      zzts: 0, // 在职天数
      noticeType: [],
      carousel: [],
      IndexNoticeList: [],
      userData: {},
      latestMsg: {
        activeName: '',
        loading: true,
        data: []
      },
      xdthData: [],
      lastList: [], // 最新服务
      loadinglastList: true,
      carouselHide: 'carouselHide',
      carouselLoading: true,
      mytodoimg: './base/images/index/icon_td@2x.png',
      myccimg: './base/images/index/cc@2x.png',
      xdimg: '/base/images/index/xd.png',
      yyzximg: '/base/images/index/yyzx.png',
      yqljimg: '/base/images/index/yqlj.png',
      yqljlist: []
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 34) {
        return value.slice(0, 34) + '...'
      }
      return value
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },

  mounted() {
    console.log(this.userInfo.subject)
    this.getjobLevel()
    this.getListNoticeType()
    this.getPhotoNotice()
    this.getPersonalCenter()
    this.getxdth()
    this.getLastList()
    this.getTENANT()
    this.getyqlj()
    this.getpersonalfileissubmit()
    // 先获取所有用户基本信息不用每次都去请求
    this.$http.post('/fighter-apis-manage/apis/query/apis-1703123256305').then(res => {
      this.baseallinfo = res.data
    })
  },
  created() {
    // this.CHANGE_TASKNUM_ASYNC()
  },
  methods: {
    goToda(data) {
      this.dangan.loginName = data.loginName
      this.dangan.dialogVisible = data.type
      this.dangan.title = data.name + '的个人档案'
      // console.log(data)
    },
    myself(data) {
      this.baseinfo = this.baseallinfo.filter(e => e.loginName === data)[0] || ''
      this.$refs.myrefpopover.$refs.refpopover.doShow()
    },
    getpopoverinfo(item, index) {
      this.baseinfo = this.baseallinfo.filter(e => e.loginName === item.sjh)[0] || ''
      this.$refs.refpopover[index].$refs.refpopover.doShow()
    },
    // 获取职级信息
    getjobLevel() {
      this.$http.post('fighter-apis-manage/apis/query/apis-1702972877743').then((res) => {
        this.jobLevel = res.data[0]
      })
    },
    // 获取个人档案是否填写
    getpersonalfileissubmit() {
      this.$http.get('/grdalc/checkSubmit').then((res) => {
        if (res.data === false) {
          this.$confirm('您的个人档案还未填写, 是否去填写?', '提示', {
            showClose: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: '去填写',
            cancelButtonText: '下次再说',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: '/applyForm?businessKey=&formId=e6a103f6697849b99e29118a85478324&pageKey=DO&showNav=no&isIframe=true&isHiddenBtn=1'
            })
          })
        }
      })
    },
    getListNoticeType() {
      this.$http.post('/notice/list', {
        entity: { status: '1' },
        orderItemList: [
          {
            asc: true,
            column: 'id'
          }
        ]
      }).then(response => {
        this.latestMsg.data = response.data,
          this.$http.get('/pub/dm-const/listByCataIdOthers', {
            params: { cataId: '82579e00c0605633472f1d40d3ba1285' }
          }).then((response) => {
            let result = []
            response.data.forEach((element) => {
              // console.log(element)
              this.latestMsg.data.forEach((obj) => {
                // console.log(obj)
                if (element.itemCode == obj.pubtype) {
                  result.forEach((res) => {
                    if (res.value == element.itemCode) {
                      result.pop()
                    }
                  })
                  result.push({
                    label: element.itemValue,
                    value: element.itemCode,
                    itemSort: element.itemSort
                  })
                }
              })
            })
            let gsgg = [{
              itemSort: 0,
              label: '公司公告',
              value: ''
            }]
            let allnoticeType = gsgg.concat(result)
            this.noticeType = allnoticeType.sort(this.sortBy('itemSort', true))
            // 如果有 加载一条
            if (result && result.length) {
              this.latestMsg.activeName = result[0].value
              this.handleClick({ name: result[0].value })
            } else {
              this.carouselLoading = false
            }
          })
            .catch((error) => {
              this.$message.error(error.msg)
            })
      })
    },
    handleClick(tab, event) {
      this.$http.post('/notice/query', {
        entity: {
          pubtype: tab.name || tab,
          status: '1'
        },
        orderItemList: [
          {
            asc: false,
            column: 'publish_time'
          }
        ]
      },
        {
          params: {
            pageNum: 1,
            pageSize: 8
          }
        }
      )
        .then((response) => {
          this.latestMsg.data = response.data.records
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getPhoto(notice) {
      // console.log(notice)
      let iconPath = notice.photo
      let iconTitle = notice.title
      // let id = notice.id
      if (!iconPath) {
        this.carouselLoading = false
        this.carouselHide = ''
        this.carousel.push({
          id: notice.id,
          src: '/base/images/index/mr_news.png',
          title: iconTitle
        })
        return
      }
      this.carouselLoading = false
      this.carouselHide = ''
      if (notice.photo !== '') {
        this.carousel.push({
          id: notice.id,
          src: window.config.FDFS_WEB_SERVER_URL + notice.photo,
          title: iconTitle
        })
      }
      // console.log(this.carousel)
    },
    getPhotoNotice(pubtype) {
      this.$http
        .post(
          '/notice/query',
          {
            entity: {
              //   pubtype: pubtype,
              status: '1'
            },
            orderItemList: [
              {
                asc: false,
                column: 'publish_time'
              }
            ]
          },
          {
            params: {
              pageNum: 1,
              pageSize: 3
            }
          }
        )
        .then((response) => {
          let dataList = []
          dataList = response.data.records
          this.carousel = []
          dataList.map((item) => {
            return this.getPhoto(item)
          })
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    goToview(content) {
      let routerJump = this.$router.resolve({
        name: '通知公告详情',
        query: { id: content.id }
      })
      window.open(routerJump.href, '_blank')
    },
    goToFw: function () {
      this.$router.push({ path: '/toServiceHallPg/index' })
    },
    goToDB: function () {
      this.$router.push({ path: '/basicInformation/index' })
    },
    goToCC: function () {
      this.$router.push({ path: '/csMine/index' })
    },
    goToMore(tabName) {
      let routerJump = this.$router.resolve({
        name: '通知公告列表',
        query: { tabName: tabName }
      })
      window.open(routerJump.href, '_blank')
    },
    // 获取账号信息
    getPersonalCenter() {
      const myDate = new Date()
      const date = {
        year: myDate.getFullYear(),
        month: myDate.getMonth() + 1,
        date: myDate.getDate()
      }
      const newmonth = date.month > 10 ? date.month : '0' + date.month
      const day = date.date > 10 ? date.date : '0' + date.date
      this.nowDate = date.year + '-' + newmonth + '-' + day
      let wk = myDate.getDay()
      let weeks = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ]
      let week = weeks[wk]
      this.nowWeek = week
      this.$http
        .get('/personalCenter/getPersonalCenter')
        .then((res) => {
          if (
            res.data.subject.accountDetail &&
            res.data.subject.accountDetail.extendInfo
          ) {
            let userData = JSON.parse(
              res.data.subject.accountDetail.extendInfo
            )
            userData.hiredDate = dateFormat(
              new Date(userData.hiredDate),
              'yyyy-MM-dd'
            )
            this.dateDiff(userData.hiredDate, this.nowDate)
            this.userData = userData
            this.txSrc = res.data.subject.avatar || userData.avatar || '/base/images/layout/user.png'
          }
          if (res.data.subject.orgList.length) {
            this.userData.department = res.data.subject.orgList[0].name
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
    },
    dateDiff(d1, d2) {
      this.zzts =
        Math.ceil(
          (new Date(d2).getTime() - new Date(d1).getTime()) /
          1000 /
          60 /
          60 /
          24
        ) + 1
    },
    getxdth() {
      this.$http.post('/vBbXrblc/query', {
        entity: {},
        orderItemList: [{ asc: false, column: 'txrq' }, { asc: false, column: 'lastUpdateTime' }, { asc: false, column: 'createTime' }],
        pageNum: 1,
        pageSize: 4
      }).then(response => {
        var list = response.data.records
        for (let i = 0; i < list.length; i++) {
          if (list[i].avatr == null) {
            list[i].avatr = '/base/images/layout/user.png'
          }
        }
        this.xdthData = list
      })
    },
    getLastList: async function () {
      let params = {}
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY
      params.appType = 'APP_TYPE_PC'
      params.pageNum = 1
      params.pageSize = 10
      await this.$http
        .post(
          '/syApp/queryScApp',
          {
            entity: { sfqy: '1', yyfl: '1' },
            orderItemList: [
              {
                asc: false,
                column: 'createTime'
              }
            ]
          },
          { params }
        )
        .then(async (response) => {
          if (response.data.size != 0) {
            this.lastListHide = ''
            this.lastList = []
            for (let i = 0; i < response.data.records.length; i++) {
              if (response.data.records[i].icons == null) {
                response.data.records[i].src =
                  '/base/images/index/xt_keyan.png'
              } else {
                response.data.records[i].src =
                  window.config.FDFS_WEB_SERVER_URL +
                  response.data.records[i].icons
              }
            }
            this.loadinglastList = false
            this.lastList = response.data.records
          } else {
            this.lastListHide = 'lastListHide'
          }
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    goToFWXQ: function (row) {
      // 判断打开方式， 2为新窗体打开
      if (row.dkfs == '2') {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj == '1') {
          let routeData = this.$router.resolve({
            name: '服务详情',
            query: { id: row.id }
          })
          window.open(
            '#' +
            routeData.location.path +
            '?id=' +
            routeData.location.query.id,
            '_blank'
          )
        } else {
          window.open(row.pcUrl, '_blank')
        }
      } else {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj === '1') {
          this.$router.push({ name: '服务详情', query: { id: row.id } })
        } else {
          // 本窗口打开
          window.location.href = row.pcUrl
          // window.open(row.pcUrl)
        }
      }
    },
    getTENANT() {
      let userInfo = getUserInfo()
      let params = userInfo.tenantId
      if (TENANT.isShow) {
        this.$http
          .get('/tenant/' + params)
          .then((response) => {
            this.tenantName = response.data.name
          })
          .catch((erro) => {
            return this.$message.error(erro.msg)
          })
      }
    },
    getyqlj() {
      let params = {}
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY
      params.appType = 'APP_TYPE_PC'
      params.pageNum = 1
      params.pageSize = 10
      this.$http.post('/fighter-lightportal-saas/syApp/queryScApp', {
        'entity': {
          'sfqy': '1',
          'yyfl': '4'
        },
        'orderItemList': [
          {
            'asc': true,
            'column': 'sort'
          }
        ]
      }, { params }).then(response => {
        var list = response.data.records
        for (let i = 0; i < list.length; i++) {
          list[i].icons = window.config.FDFS_WEB_SERVER_URL + list[i].icons
        }
        this.yqljlist = list
        // console.log(list)
      })
    },
    sortBy: function (attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1
      } else {
        rev = (rev) ? 1 : -1
      }

      return function (a, b) {
        a = a[attr]
        b = b[attr]
        if (a < b) {
          return rev * -1
        }
        if (a > b) {
          return rev * 1
        }
        return 0
      }
    },
    goToxd() {
      this.$router.push(
        {
          path: '/Experience/index'
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus) {
  background-color: transparent !important;
  color: #1871db !important;
}
.avue-main--fullscreen {
  margin-top: 0 !important;
}
.avue-main {
  background-color: #f8f8f8;
}
.system_index {
  max-width: 1680px;
  width: calc(100% - 340px);
  min-width: 1280px;
  height: 100%;
  margin: 15px auto 0;
}
.bgWhite {
  background-color: #fff;
}
.index_content {
  // margin-top: 15px;
  position: relative;
}
.cLoading :deep(.el-loading-spinner) {
  margin-top: -188px;
}
.more {
  flex: 1;
  text-align: right;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  background: url("/base/images/index/more.png") no-repeat right center;
  background-size: 8px 10px;
  padding-right: 15px;
}
.common-head {
  height: 60px;
  border-bottom: 1px solid #e4e8ef;
  display: flex;
  align-items: center;
  padding: 0 10px;
  color: #1871db !important;
}
.head-title {
  display: flex;
  line-height: 1;
  padding-left: 6px;
  font-size: 16px;
  // font-weight: 700;
  color: #1871db;
  & img {
    width: 18px;
    display: inline-block;
  }
  & .title_span {
    padding: 0 20px 0 8px;
  }
}
.common-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  & .xdlist {
    list-style: none;
    padding-left: 0;
    margin: 0;
    min-height: 293px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    & li {
      display: flex;
      width: 100%;
      // padding-bottom: 10px;
      // margin-bottom: 38px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    // .useravatr {
    //   & img {
    //     width: 56px;
    //     height: 56px;
    //     border-radius: 50%;
    //     margin-right: 10px;
    //   }
    // }
    & .xdlistinfo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex: 1;
      padding-left: 10px;
      & .xm {
        font-size: 14px;
        font-weight: 600;
      }
      & .date {
        font-size: 12px;
        color: #999;
        margin-left: 10px;
      }
      & .xd {
        color: #333;
        font-size: 13px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        // width: 260px;
      }
    }
    & .userinfo {
      display: none;
    }
  }
}
.tzzx-list {
  width: 100%;
  height: 280px;
  overflow: hidden;
  margin: 0;
  padding-left: 10px;
}

.notice-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 1.75;
}
.notice-list p {
  cursor: pointer;
  margin: 0;
}
.notice-list .iconSize {
  width: 18px;
  height: 18px;
}
.tzzx-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tzzx-list li img {
  margin-right: 5px;
}

.tzzx-list li .title {
  width: 310px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  color: #666;
}
.tzzx-list li span .date {
  // width: 60px;
  text-align: right;
}

.tzzx-list li .date {
  color: #aaa;
  font-size: 0.875rem;
}
.tzzx-list li .title:hover {
  color: #1871db;
}
.carousel_title {
  position: absolute;
  bottom: 0;
  background-color: #1a1a1a5c;
  font-size: 13px;
  width: 100%;
  text-align: center;
  color: white;
  padding: 4px 0;
  box-sizing: border-box;
  display: block;
  margin: 0;
}
.indexNewsList > li {
  padding: 0 15px;
  & span {
    font-size: 14px !important;
  }
}
.indexNewsList > li.is-active {
  background-color: transparent !important;
  border-bottom: 0.125rem solid #1871db;
  color: #1871db;
}
.indexNewsList li span:hover {
  color: #1871db !important;
}
.part_1 {
  margin-bottom: 0;
}
.head {
  width: 88px;
  height: 88px;
  margin: 30px auto 0;
}
.userinfoData {
  height: 340px;
  padding: 15px;
  overflow: hidden;
  & p {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    & .line {
      width: 0.05rem;
      height: 16px;
      background: #666;
      margin: 0 3px;
    }
  }
  & .userName {
    margin-bottom: 10px;
  }
  & .welcome {
    margin: 0;
    font-size: 16px;
    color: #999;
    font-weight: normal;
    & .work-day {
      color: #1871db;
      font-weight: 700;
    }
  }
  & .mytodo {
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: space-evenly;
    font-size: 14px;
    margin-top: 45px;
    & div {
      // padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
    & .line {
      width: 0.05rem;
      height: 70px;
      background: #666;
      // margin: 0 3px;
      padding: 0;
      margin-right: 10px;
    }
    & .pdt10 {
      padding-top: 10px;
      color: #222;
    }
    & .today {
      align-items: flex-start;
      height: 70px;
      display: flex;
      & .nowWeek {
        font-weight: 700;
      }
      & span {
        // font-size: 12px;
        margin: 5px 0;
      }
    }
    .iconsize {
      width: 40px;
    }
  }
}
.expressLane_content_div {
  // padding-bottom: 1.875rem;
  min-height: 185px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .zxyx {
    width: 20%;
    padding: 9px 0;
  }
}
.expressLane_content_xt {
  // margin-top: 30px;
  // margin-bottom: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.expressLane_img {
  width: 70px;
  height: 70px;
  vertical-align: middle;
}
.common-yqlj {
  padding: 15px;
}
.yqlj {
  margin: 0 5px;
  ul {
    list-style: none;
    display: flex;
    justify-content: space-around;
    li {
      img {
        width: 130px;
        margin-right: 15px;
      }
      div {
        a {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            padding-top: 5px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.zl_module {
  margin-top: 20px;
  .line {
    display: inline-block;
    line-height: 1px;
    border-top: 1px solid #d5d5d5;
    width: 45%;
  }
  .font {
    display: inline-block;
    width: 10%;
    text-align: center;
    color: #a9acba;
    font-size: 12px;
  }
}

.useravatar {
  width: 60px;
  height: 60px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: fill;
  }
}
</style>
